module.exports = __webpack_public_path__ + "static/media/x.00227e0a.svg";